var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9974 19.6531C23.5232 19.6531 25.5778 17.5978 25.5778 15.072C25.5778 12.5462 23.5232 10.4912 20.9974 10.4912C18.4716 10.4912 16.417 12.5458 16.417 15.0716C16.417 17.5978 18.4716 19.653 20.9974 19.653V19.6531ZM20.9974 11.4916C22.9714 11.4916 24.5779 13.098 24.5779 15.0721C24.5779 17.0468 22.9715 18.6532 20.9974 18.6532C19.0233 18.6532 17.4169 17.0468 17.4169 15.0721C17.4169 13.0981 19.0233 11.4916 20.9974 11.4916Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.997 21.5728C16.0909 21.5728 12.104 25.4166 11.9203 30.323C11.9151 30.4587 11.9653 30.5905 12.0598 30.6882C12.154 30.7862 12.2841 30.8417 12.4197 30.8417H29.574C29.7097 30.8417 29.8398 30.7865 29.934 30.6882C30.0288 30.5905 30.0791 30.4587 30.0735 30.323C29.89 25.4166 25.9032 21.5728 20.9968 21.5728H20.997ZM12.9551 29.8417C13.3677 25.7262 16.8055 22.573 20.997 22.573C25.1885 22.573 28.6263 25.7262 29.0389 29.8421L12.9551 29.8417Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.997 0.666504H8.99718C4.58597 0.666504 0.99707 4.25531 0.99707 8.66661V32.6664C0.99707 37.0776 4.58588 40.6665 8.99718 40.6665H32.997C37.4082 40.6665 40.9971 37.0777 40.9971 32.6664L40.9967 8.66661C40.9967 4.2554 37.4079 0.666504 32.9966 0.666504H32.997ZM39.9971 32.6662C39.9971 36.526 36.8571 39.666 32.9973 39.666L8.99753 39.6663C5.13775 39.6663 1.99777 36.5264 1.99777 32.6666L1.99743 8.66678C1.99743 4.80699 5.1374 1.66702 8.99719 1.66702H32.997C36.8568 1.66702 39.9967 4.80699 39.9967 8.66678L39.9971 32.6662Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.6ba5499ad182d39ac1b85f92d3bc6eaa.svg";
export { ForwardRef as ReactComponent };